document.addEventListener('DOMContentLoaded', () => {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Swiper's loop reorders real slides, so it needs roughly twice the visible
  // count to shuffle without a visible jump. With only a handful of blocks we
  // repeat the set in the track instead — clones are decorative only.
  function fillTrack(wrapper, needed) {
    const originals = Array.from(wrapper.children);
    if (!originals.length) return;

    let count = originals.length;
    while (count < needed) {
      originals.forEach((slide) => {
        if (count >= needed) return;
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        Array.from(clone.attributes).forEach((attr) => {
          if (attr.name.indexOf('data-shopify-editor') === 0) clone.removeAttribute(attr.name);
        });
        wrapper.appendChild(clone);
        count += 1;
      });
    }
  }

  function initSection(root) {
    if (root.dataset.suInit) return;
    if (typeof Swiper === 'undefined') return;
    root.dataset.suInit = 'true';

    const swiperEl = root.querySelector('.sych-unbox__swiper');
    const wrapperEl = root.querySelector('.sych-unbox__swiper .swiper-wrapper');
    const paginationEl = root.querySelector('.sych-unbox__dots');
    if (!swiperEl || !wrapperEl) return;

    const perDesktop = parseInt(root.dataset.perDesktop, 10) || 4;
    const perLaptop = parseInt(root.dataset.perLaptop, 10) || 3;
    const perTablet = parseInt(root.dataset.perTablet, 10) || 2;
    const perMobile = parseInt(root.dataset.perMobile, 10) || 1;
    const maxPerView = Math.max(perDesktop, perLaptop, perTablet, perMobile);

    const autoplayDelay = parseInt(root.dataset.autoplay, 10) || 0;
    const transitionSpeed = parseInt(root.dataset.speed, 10) || 3000;
    const pauseOnHover = root.dataset.pauseOnHover !== 'false';
    const wantsLoop = root.dataset.loop !== 'false';
    const wantsContinuous = root.dataset.autoplayMode === 'continuous';

    const realSlides = wrapperEl.querySelectorAll('.swiper-slide').length;
    const autoplayOn = autoplayDelay > 0 && !REDUCED_MOTION && realSlides > 1;

    // A marquee has to wrap, so it earns the extra slides; slide-by-slide mode
    // keeps its real dot count and simply skips looping when it can't.
    const marquee = autoplayOn && wantsContinuous;
    if (marquee) {
      root.classList.add('sych-unbox--marquee');
      fillTrack(wrapperEl, maxPerView * 2 + 1);
    }

    const slideCount = wrapperEl.querySelectorAll('.swiper-slide').length;
    const loop = (marquee || wantsLoop) && slideCount >= maxPerView * 2;

    if (marquee && paginationEl) paginationEl.classList.add('is-hidden');

    const options = {
      slidesPerView: perMobile,
      spaceBetween: 10,
      watchOverflow: !marquee,
      loop: loop,
      loopAddBlankSlides: false,
      rewind: !loop && !marquee,
      speed: marquee ? transitionSpeed : 600,
      pagination: marquee ? false : { el: paginationEl, clickable: true },
      breakpoints: {
        501: { slidesPerView: perTablet },
        992: { slidesPerView: perLaptop },
        1200: { slidesPerView: perDesktop },
      },
    };

    if (autoplayOn) {
      options.autoplay = {
        // Swiper treats delay 0 as unset, so 1ms is what keeps a marquee seamless.
        delay: marquee ? 1 : autoplayDelay,
        pauseOnMouseEnter: pauseOnHover,
        disableOnInteraction: false,
      };
    }

    const swiper = new Swiper(swiperEl, options);

    if (!autoplayOn || !swiper.autoplay) return;

    // Touch drag can leave autoplay parked; nudge it back once the finger lifts.
    swiperEl.addEventListener('touchend', () => swiper.autoplay.start(), { passive: true });

    // Don't animate a section nobody is looking at.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              swiper.autoplay.start();
            } else {
              swiper.autoplay.stop();
            }
          });
        },
        { threshold: 0 }
      ).observe(root);
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sych-unboxing]').forEach(initSection);
  }

  init(document);

  document.addEventListener('shopify:section:load', (event) => init(event.target));
});
